'use client';

import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { type ReactNode, useEffect } from 'react';

import { useMsalAccount } from '../../contexts/TokenContext/useMsalAccount';

export function AppInsightsUserLogger(): ReactNode {
	const app = useAppInsightsContext();
	const setUserContext = app?.context?.user?.setAuthenticatedUserContext;

	const account = useMsalAccount();
	const uid = account?.homeAccountId;

	useEffect(() => {
		// No user
		if (!uid) {
			return;
		}

		// TODO: should we enable storing in cookies?
		// Update App Insight's user context
		setUserContext?.(account.username, uid);
	}, [setUserContext, account, uid]);

	return null;
}
